<template>
  <div>


 <section class="bg" style=""><span class="overlay" style="background-color: #000; opacity: .5;"></span>
<div class="bg"></div>
 </section>




  <section class="container padding-top-0x padding-bottom-0x">
     <div class="owl-carousel" id="mhdfeature">
        <div class="text-center">
          <span class="d-block display-4 text-gray-light mb-4">
            <i class="material-icons flight"></i></span>
          <h4 class="h6 mb-2"><strong>LIVRAISON EXPRESS ET GRATUITE </strong> </h4>
          <p class="text-sm text-muted mb-0"> lIVRAISON GRATUITE POUR LES 48 WILAYAS</p>
        </div>
        <div class="text-center">
          <span class="d-block display-4 text-gray-light mb-4">
            <i class="material-icons autorenew"></i></span>
          <h4 class="h6 mb-2"><strong> GARANTIE DE DEUX ANS </strong></h4>
          <p class="text-sm text-muted mb-0">Garantie de deux (02) ans sur tous nos produits </p>
        </div>
        <div class="text-center">
          <span class="d-block display-4 text-gray-light mb-4">
            <i class="material-icons headset_mic"></i></span>
          <h4 class="h6 mb-2"><strong> 24/7 Support en ligne </strong> </h4>
          <p class="text-sm text-muted mb-0">Assistance clientèle 24/7</p>
        </div>

     </div>
    </section>




<div class="wsite-section wsite-body-section wsite-background-1 wsite-custom-background" >
		<div class="wsite-section-content">
			<div class="container">
			<div class="wsite-section-elements">
<div><div class="wsite-multicol"><div class="wsite-multicol-table-wrap" style="margin:0 -15px;">
	<table class="wsite-multicol-table">
		<tbody class="wsite-multicol-tbody">
				<td class="wsite-multicol-col" style="width:25.151515151515%; padding:0 15px;">
<div class="wsite-spacer" style="height:50px;"></div>
	</td>				<td class="wsite-multicol-col" style="width:50.20202020202%; padding:0 15px;">
		</td>				<td class="wsite-multicol-col" style="width:24.646464646465%; padding:0 15px;">
<div class="wsite-spacer" style="height:50px;"></div>
	</td>
		</tbody>
	</table>
</div></div></div>
<div><div class="wsite-multicol"><div class="wsite-multicol-table-wrap" style="margin:0 -5px;">
	<table class="wsite-multicol-table">
		<tbody class="wsite-multicol-tbody">
				<td class="wsite-multicol-col" style="width:50%; padding:0 5px;">
<div><router-link class="wsite-image wsite-image-border-none "  to="/women"  style="padding-top:10px;padding-bottom:5px;margin-left:0;margin-right:0;text-align:center">
<a>
<img src="/womenmobile.jpg" alt="Picture" style="width:auto;max-width:100%">
</a>
<div style="display:block;font-size:90%"></div>
</router-link></div>
	</td>				<td class="wsite-multicol-col" style="width:50%; padding:0 5px;">
<div><router-link class="wsite-image wsite-image-border-none"  to="/men" style="padding-top:10px;padding-bottom:5px;margin-left:0;margin-right:0;text-align:center">
<a>
<img src="/luipc.jpg" alt="Picture" style="width:auto;max-width:100%">
</a>
<div style="display:block;font-size:90%"></div>
</router-link></div>
	</td>
		</tbody>
	</table>
</div></div></div>
			</div>
		</div>
		</div>
	</div>
  <br>
   <br>

 <section class="container-fluid bg-bg-secondary padding-bottom-3x pb-5" >
   <div class="text-center">

          <h6 class="h6 mb-2"><strong> Nouveautés FEMME </strong></h6>
          <h6><p class="text-sm text-muted mb-0"> <strong>Découvrez les nouveautés qui viennent d'arriver chez LUXURY SHOP DZ ! </strong></p> </h6>
        </div>
    <div id="top-category" class="owl-carousel" >
       <div v-for="product in products" v-bind:key="product.id">
              <div class="card">
                <router-link to="/product" @click.native="ProductDetail(product)">
                <img class="card-img-top" :src="product.photo"  alt="Card image">
                </router-link>
                <div class="card-body">
                 <h3 class="product-card-title"><b><strong>{{product.description}}</strong></b></h3>
                  <span class="h6 d-block">
              <del class="text-muted text-normal"></del>&nbsp;{{product.price}} DA</span>
                  <button class="btn btn-primary btn-sm"
                   @click="addToCart(product)"><strong>Ajouter au panier</strong></button>
                </div>
              </div>
        </div>
      </div>
  </section>

 <section class="container-fluid bg-bg-secondary padding-bottom-3x pb-5" >
   <div class="text-center">

          <h6 class="h6 mb-2"><strong> Nouveautés HOMME</strong></h6>
          <h6><p class="text-sm text-muted mb-0"> <strong>Découvrez les nouveautés qui viennent d'arriver chez LUXURY SHOP DZ ! </strong></p> </h6>
        </div>
    <div id="top-categoryH" class="owl-carousel" >
       <div v-for="product in products2" v-bind:key="product.id">
         <div class="card">
                <router-link to="/product" @click.native="ProductDetail2(product)">
                <img class="card-img-top" :src="product.photo"  alt="Card image">
                </router-link>
                <div class="card-body">
                  <h3 class="product-card-title"><b><strong>{{product.description}}</strong></b></h3>
                  <span class="h6 d-block">
              <del class="text-muted text-normal"></del>&nbsp;{{product.price}} DA</span>
                  <button class="btn btn-primary btn-sm"
                   @click="addToCart(product)"><strong>Ajouter au panier</strong></button>
                </div>
              </div>

        </div>
      </div>
  </section>









 <section class="container-fluid bg-bg-secondary padding-bottom-3x pb-5" >
    <div id="top-category2" class="">
       <div >
              <div class="card">

 <div class="d-flex justify-content-center" style="background-image: url(static/img/main-bg.jpg);">
              <div class="px-3 text-center">
                <img src="/mklogo.jpg" style="border:solid 2px #000000;" alt="Category">
                <h2 class="display-2 text-bold text-white text-shadow"></h2>
                <div class="view-button"><a class="btn btn-primary" href="/#/Michaelkors">Voir la collection</a></div>

              </div>
           </div>
            <div class="d-flex justify-content-center" style="background-image: url(static/img/main-bg.jpg);">
              <div class="px-3 text-center">
                <img src="/festina-logo.jpg" style="border:solid 2px #000000;" alt="Category">
                <h2 class="display-2 text-bold text-white text-shadow"></h2>
                <div class="view-button"><a class="btn btn-primary" href="/#/festina">Voir la collection</a></div>

              </div>
           </div>
           <div class="d-flex justify-content-center" style="background-image: url(static/img/main-bg.jpg);">
              <div class="px-3 text-center">
                <img src="/axlogo.jpg" style="border:solid 2px #000000;" alt="Category">
                <h2 class="display-2 text-bold text-white text-shadow"></h2>
                <div class="view-button"><a class="btn btn-primary" href="/#/armani">Voir la collection</a></div>

              </div>
           </div>
           <div class="d-flex justify-content-center" style="background-image: url(static/img/main-bg.jpg);">
              <div class="px-3 text-center">
                <img src="/fossillogo.jpg" style="border:solid 2px #000000;" alt="Category">
                <h2 class="display-2 text-bold text-white text-shadow"></h2>
                <div class="view-button"><a class="btn btn-primary" href="/#/fossil">Voir la collection</a></div>

              </div>
           </div>
       
              </div>
        </div>
      </div>
  </section>









  </div>

</template>
    <!-- JavaScript (jQuery) libraries, plugins and custom scripts-->
    <script src="vendor.min.js"></script>
    <script src="scripts.min.js"></script>
    <!-- Customizer scripts-->
    <script src="customizer/customizer.min.js"></script>
<script>
//for carousel in home page
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';
import $ from 'jquery';

import { mapGetters, mapActions } from 'vuex';
import eventBus from '../main.js';

export default {
  data() {
    return {
      show: true
    };
  },
  computed: {
    fetchComplete() {
      return this.$store.state.fetchedData;
    },
     ...mapGetters({

      products: 'lastProducts',
      products2: 'lastProducts2'
    }),
  },
   watch: {
    fetchComplete() {
      if (this.fetchComplete) {
        //create the owl carousel until i fetch the data fechedData=true in the store
        this.$nextTick(() => {
          $('#top-category').owlCarousel({
            nav: false,
            dots: true,
            margin: 30,
            responsiveClass: true,
            autoplay :true,
            autoplayTimeout :7000,
            loop :true,
            dots:true,
            responsive: {
              0: { items: 1 },
              576: { items: 2 },
              768: { items: 3 },
              991: { items: 4 },
              1200: { items: 4 }
            }
          });
             $('#top-categoryH').owlCarousel({
            nav: false,
            dots: true,
            margin: 30,
            responsiveClass: true,
            autoplay :true,
            autoplayTimeout :7000,
            loop :true,
            dots:true,
            responsive: {
              0: { items: 1 },
              576: { items: 2 },
              768: { items: 3 },
              991: { items: 4 },
              1200: { items: 4 }
            }
          });
      });
      }
    }
  },
  //need this for redirection from another page like from all back to home
  mounted() {
    if (this.fetchComplete) {
      this.$nextTick(() => {
        $('#top-category').owlCarousel({
          nav: false,
          dots: true,
          margin: 30,
          responsiveClass: true,
          autoplay :true,
            autoplayTimeout :7000,
            loop :true,
            dots:true,
          responsive: {
            0: { items: 1 },
            576: { items: 2 },
            768: { items: 3 },
            991: { items: 4 },
            1200: { items: 4 }
          }
        });
             $('#top-categoryH').owlCarousel({
          nav: false,
          dots: true,
          margin: 30,
          responsiveClass: true,
          autoplay :true,
            autoplayTimeout :7000,
            loop :true,
            dots:true,
          responsive: {
            0: { items: 1 },
            576: { items: 2 },
            768: { items: 3 },
            991: { items: 4 },
            1200: { items: 4 }
          }
        });
      });
    }
  },
  created() {
    this.$store.dispatch('lastProduct', { limit: 18 });

this.$nextTick(() => {
      $('#mhdfeature').owlCarousel({
        nav: false,
        dots: true,
        margin: 30,
        responsive: {
          0: { items: 1 },
          576: { items: 2 },
          768: { items: 3 },
          991: { items: 3 },
          1200: { items: 3 }
        }
      });
      $('#slide').owlCarousel({
        items: 1,
        loop: true,
        autoplay: true,
        autoplayTimeout: 8000
      });
  $('#brands').owlCarousel({
        nav: false,
        dots: false,
        loop: true,
        autoplay: true,
        autoplayTimeout: 4000,
        responsive: {
          0: { items: 2 },
          470: { items: 3 },
          630: { items: 4 },
          991: { items: 5 },
          1200: { items: 6 }
        }
      });


    });


  },



  data() {
    return {
      sales: false,
      discount: 0
    };
  },

  methods: {
    addToCart: function(item) {
      this.$store
        .dispatch('addToCart', item)
        .then(() => {
          this.$notify({
            group: 'cart',
            title: 'Product',
            type: 'success',
            text: 'vous avez ajouter un produit au panier'
          });
        })
        .catch(error => console.log(error));
    },
    ...mapActions(['ProductDetail','ProductDetail2'])
  }
};
</script>

<style scoped>
.card-img-top {
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
}
.card-img-top2 {
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
}



.men-card {
  background-image: url('/luipc.jpg');
  background-size: cover;
  height: 100%;

}
@media  (max-width: 600px) {
 .men-card  {
  background-image: url('/luipcmobile.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 25vh;
  margin-bottom: 10px;
}


}
.women-card {
  background-image: url('/womenpc.jpg');
  background-size: cover;
  height: 100%;
}
@media  (max-width: 600px) {
 .women-card  {
  background-image: url('/womenmobile.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
    height: 25vh;
  margin-bottom: 10px;


}
}
.women-card img {
  opacity: 0;
  /*or visibility: hidden;*/
}

.men-card img {
  opacity: 0;
}

.women-card h3 {
  font-size: 1em;
  color: whitesmoke;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 0.3em;
}

.men-card h3 {
  font-size: 1em;
  color: whitesmoke;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 0.3em;
}

.women-card button {
  z-index: 1;
  opacity: 0;
  transition: opacity 0.35s;
  position: absolute;
  right: 20px;
  bottom: 20px;
}
.women-card:hover button {
  opacity: 1;
}


.card-body button {
  position: absolute;
  right: 0;
  bottom: 5px;
}

.product-card-buttons:active button {
  opacity: 1;
}
.product-card-buttons:focus button {
  opacity: 1;
}
.bg {
  background-image: url('/home.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 70vh;
  margin-bottom: 30px;


}
.mr-top-30 {
  margin-top: 30px;
}
.mr-top-40 {
  margin-top: 40px;
}
@media  (max-width: 900px) {
 .bg {
  background-image: url('/homemobile.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 60vh;
  margin-bottom: 30px;
}


}



</style>






// WEBPACK FOOTER //
// src/components/home.vue